<style lang="scss" scoped>
.onboarding-page {
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
    overflow: auto;
}
.bg-primary-gradient {
    background-image: linear-gradient(
        180deg,
        var(--primary) 0%,
        var(--primary-dark) 100%
    );
}
.side-bar {
    @media screen and (min-width: 768px) and (max-width: 1024px) {
        position: fixed;
        right: 0;
        height: 100%;
    }
}
.cushion {
    position: absolute;
    width: 65px;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto -32px auto;
    @media (min-width: 992px) {
        width: 192px;
        height: 182px;
        margin: 0 0 0 calc(-192px / 2);
        top: 65px;
    }
}
.mobile-nav {
    position: relative;
    background-image: linear-gradient(180deg, #005794 0%, #0f3261 100%);
    height: 54px;
}
</style> 

<template>
    <div class="onboarding-page container-fluid">
        <div class="mobile-nav d-lg-none row">
            <img class="cushion" src="/images/cushion.png" alt="Start to sleep">
        </div>

        <div class="row h-100">
            <div class="col-12 col-lg-10 col-xl-9 order-2 order-lg-1">
                <div class="container mt-44 mt-lg-0 pb-xl-0 px-0 px-lg-32 pt-lg-32 px-xl-100 pt-xl-100 h-100">
                    <router-view class="h-100" :key="$route.path" />
                </div>
            </div>
            <div class="col-12 col-lg-2 col-xl-3 px-0 order-1 order-lg-2 bg-primary-gradient d-none d-lg-block side-bar">
                <img class="cushion d-none d-xl-block" src="/images/cushion.png" alt="Start to sleep">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'index-onboarding',
};
</script>
